import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, User, ArrowLeft, Ticket } from 'lucide-react';
import TicketStatusBadge from './TicketStatusBadge';
import { formatSlot, userDisplayName } from '../utils/ticketDisplay';
import type { RecordingTicket } from '../hooks/useTickets';

interface TicketRecordingHeaderProps {
  ticket: RecordingTicket;
}

const TicketRecordingHeader: React.FC<TicketRecordingHeaderProps> = ({ ticket }) => {
  return (
    <div className="etr-surface border border-primary-200 bg-primary-50/50 p-4 sm:p-5 mb-6">
      <div className="flex flex-wrap items-start justify-between gap-3 mb-3">
        <div className="flex items-center gap-2 text-sm font-medium text-primary-800">
          <Ticket className="h-4 w-4" />
          Recording for ticket
        </div>
        <TicketStatusBadge status={ticket.status} />
      </div>
      <h2 className="text-lg sm:text-xl font-semibold text-gray-900">{ticket.title}</h2>
      {ticket.ticketNumber && (
        <p className="text-sm font-mono text-gray-500 mt-1">{ticket.ticketNumber}</p>
      )}
      <div className="flex flex-wrap gap-4 text-sm text-gray-600 mt-3">
        {ticket.slotStartAt && (
          <span className="flex items-center gap-1">
            <Calendar className="h-4 w-4" />
            {formatSlot(ticket.slotStartAt)}
          </span>
        )}
        {ticket.requestedBy && (
          <span className="flex items-center gap-1">
            <User className="h-4 w-4" />
            Requested by {userDisplayName(ticket.requestedBy)}
          </span>
        )}
      </div>
      {ticket.notes && (
        <p className="mt-3 text-sm text-gray-700 bg-white/80 rounded p-3 border border-gray-200">
          <span className="font-medium">Notes:</span> {ticket.notes}
        </p>
      )}
      <Link
        to="/my-tickets"
        className="inline-flex items-center gap-1 text-sm text-primary-700 hover:text-primary-900 mt-4"
      >
        <ArrowLeft className="h-4 w-4" />
        Back to My Tickets
      </Link>
    </div>
  );
};

export default TicketRecordingHeader;
